import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import AppLayout from "./layouts/AppLayout";
import LoginContainer from "./auth/LoginContainer";
import Authenticate from "./auth/Authenticate";
import Fallback from "./layouts/Fallback";
import FunnelContainer from "./app/FunnelContainer";
import MetricasAgenteComercialContainer from "./app/MetricasAgenteComercialContainer";
import RevenueContainer from "./app/RevenueContainer";
import MerchantsContainer from "./app/MerchantsContainer";
import AgentCreatorContainer from "./app/AgentCreatorContainer";
import ExperimentsContainer from "./app/ExperimentsContainer";

const RouterContainer = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Navigate to="/auth/login" replace />} />

        {/* Authenticate routes */}
        <Route path="/authenticate" element={<Authenticate />} />

        {/* Auth routes */}
        <Route path="auth/login" element={<LoginContainer />} />

        {/* Main app routes */}
        <Route element={<AppLayout />}>
          <Route path="/funnel" element={<FunnelContainer />} />
          <Route
            path="/metricas-agente-comercial"
            element={<MetricasAgenteComercialContainer />}
          />
          <Route path="/revenue" element={<RevenueContainer />} />
          <Route path="/merchants" element={<MerchantsContainer />} />
          <Route path="/agent-creator" element={<AgentCreatorContainer />} />
          <Route path="/experiments" element={<ExperimentsContainer />} />
        </Route>

        {/* Redirect for unmatched routes */}
        <Route path="*" element={<Fallback />} />
      </Routes>
    </BrowserRouter>
  );
};

export default RouterContainer;
